module.exports = __webpack_public_path__ + "img/13.e05bd6e4.png";